module.exports = __webpack_public_path__ + "static/media/r27.894aa40a.webp";